import ContentListPage from "./ContentListPage";

function BlogsListPage() {
  return (
    <ContentListPage
      contentType="blog"
      title="Blogs"
      addLabel="Add Blog"
      addPath="/admin/add-blog"
      editPathPrefix="/admin/add-blog"
      viewPathPrefix="/blog"
      emptyText="No blogs yet. Click Add Blog to create one."
      searchPlaceholder="Search by heading, category or description..."
    />
  );
}

export default BlogsListPage;
